import React from 'react';
import { ReactComponent as ProductTestingSvg } from 'assets/icons/Nav/ProductTesting.svg';
import { ReactComponent as ProductManagementSvg } from 'assets/icons/Nav/ProductManagement.svg';
import { ReactComponent as CommonFileSvg } from 'assets/icons/files/Common.svg';
import { ADD_DATA_ACTIONS } from './components/AddDataModal';

export const getTestDataPayload = (values) => {
  const obj = {
    countryListId: values.exportMarket || null,
    testItemId: values.testItem || '',
    citationId: values.citationId || null,
    reportId: values.reportId || '',
    serviceProviderId: values.issueParty || null,
    result: values.testResult || '',
    expiryDate: values.expiryDate ? values.expiryDate.format('YYYY-MM-DD') : '',
    testDate: values.testDate ? values.testDate.format('YYYY-MM-DD') : '',
    documentListIds: [
      ...(values.existingFiles || []),
      ...(values.newDocumentListIds || []),
    ].map((v) => Number(v)),
  };
  if (values.id) {
    obj.id = values.id;
  }
  return obj;
};
export const getCertificateDataPayload = (values) => {
  const obj = {
    certificateTypeId: values.type || null,
    customCertificateScoreId: values.score || null,
    customIssuePartyId: values.issueParty || null,
    expiryDate: values.expiryDate ? values.expiryDate.format('YYYY-MM-DD') : '',
    testDate: values.testDate ? values.testDate.format('YYYY-MM-DD') : '',
    documentListIds: [
      ...(values.existingFiles || []),
      ...(values.newDocumentListIds || []),
    ].map((v) => Number(v)),
  };
  if (values.id) {
    obj.id = values.id;
  }
  return obj;
};
export const getOtherDataPayload = (values) => {
  const obj = {
    name: values.name || '',
    description: values.description || '',
    result: values.testResult || '',
    customComplianceOtherDataTypeId: values.type || null,
    customIssuePartyId: values.issueParty || null,
    expiryDate: values.expiryDate ? values.expiryDate.format('YYYY-MM-DD') : '',
    testDate: values.testDate ? values.testDate.format('YYYY-MM-DD') : '',
    documentListIds: [
      ...(values.existingFiles || []),
      ...(values.newDocumentListIds || []),
    ].map((v) => Number(v)),
  };
  if (values.id) {
    obj.id = values.id;
  }
  return obj;
};

export const getAddDataModalTitle = (tAction) => {
  switch (tAction) {
    case ADD_DATA_ACTIONS.TEST_DATA:
      return (
        <>
          <ProductTestingSvg />
          <span>Test Data</span>
        </>
      );
    case ADD_DATA_ACTIONS.CERTIFICATE_DATA:
      return (
        <>
          <ProductManagementSvg />
          <span>Certificate Data</span>
        </>
      );
    case ADD_DATA_ACTIONS.OTHER_DATA:
      return (
        <>
          <CommonFileSvg />
          <span>Other</span>
        </>
      );

    default:
      return '';
  }
};

export const MODAL_DATA_KEY_MAPPING = {
  [ADD_DATA_ACTIONS.TEST_DATA]: 'test-data',
  [ADD_DATA_ACTIONS.CERTIFICATE_DATA]: 'certificate-data',
  [ADD_DATA_ACTIONS.OTHER_DATA]: 'other-data',
};
export const MODAL_PAYLOAD_FN_KEY_MAPPING = {
  [ADD_DATA_ACTIONS.TEST_DATA]: getTestDataPayload,
  [ADD_DATA_ACTIONS.CERTIFICATE_DATA]: getCertificateDataPayload,
  [ADD_DATA_ACTIONS.OTHER_DATA]: getOtherDataPayload,
};
